<template>
    <div v-if="showMainSearch"
            class="fixed inset-0 z-10 h-screen w-screen cursor-pointer bg-black opacity-40"
            @click="toggleMainSearch"
        ></div>
    <header
        v-if="isOnIndex || isOnSearchResults || isOnListing || isOnProfile || isOnActivation"
        class="bg-white"
        :class="{
            'lg:sticky lg:left-0 lg:right-0 lg:top-0 lg:z-10': isOnIndex || isOnActivation,
            'sticky left-0 right-0 top-0 z-10': isOnListing,
            'z-10 lg:sticky lg:left-0 lg:right-0 lg:top-0': isOnSearchResults,
            'sticky left-0 right-0 top-0 z-10 max-md:mb-8': isOnProfile,
            'border-b': isOnActivation,
            ' ':
                !isOnIndex &&
                !isOnSearchResults &&
                !isOnListing &&
                !isOnProfile &&
                !isOnActivation,
        }"
    >
        <section is-on-desktop-head class="w-ful bg-white max-lg:hidden">
            <div
                class="container mx-auto flex h-[72px] w-full flex-row items-center justify-between bg-white px-12 pb-4 pt-4"
            >
                <figure class="flex items-center gap-6">
                    <a href="/">
                        <v-icon icon="n24-beta" class="max-md:h-5"></v-icon>
                    </a>

                    <a
                        class="button button--large button--white"
                        @click="toggleMainSearch"
                        v-if="hasSearch"
                    >
                        <!-- :class="{
                            'hidden lg:flex': hasBottomNavigation,
                        }" -->
                        <v-icon icon="loupe"></v-icon>
                        Iskanje
                    </a>
                </figure>
                <figure class="flex gap-4">
                    <!--
                    Tu bo prišla večjezičnost
                    <v-dropdown-sm>
                        <template v-slot:trigger>
                            <button class="flex items-center justify-center group">
                                <img src="/assets/images/countries/si.svg" v-if="headerSetupData.country == 'SVN'" alt="" class="h-10 w-10 shadow-sm rounded-full group-hover:shadow">
                                <img src="/assets/images/countries/hr.svg" v-if="headerSetupData.country == 'HRV'" alt="" class="h-10 w-10 shadow-sm rounded-full group-hover:shadow">
                            </button>
                        </template>
                        <template v-slot:content>
                            <div class="flex flex-col gap-3.5">
                                <a href="/drzava/svn" class="hover:text-green">
                                    Slovenija
                                </a>
                                <a href="/drzava/hrv" class="hover:text-green">
                                    Hrvaška
                                </a>
                            </div>
                        </template>
                    </v-dropdown-sm>
                    -->
                    <template v-if="hasAddListing">
                        <a
                            v-if="headerSetupData.isAuthenticated"
                            :href="headerSetupData.createListingRoute"
                            class="button button--large button--white"
                            :class="{
                                'hidden lg:flex': hasBottomNavigation,
                            }"
                        >
                            <v-icon icon="add-listing"></v-icon>
                            Objavite oglas
                        </a>
                        <template v-else>
                            <v-login
                                :class="{
                                    'hidden lg:block': hasSearchActive,
                                }"
                                :login-show="false"
                                :login-error="headerSetupData.loginError"
                                :facebook-login-route="headerSetupData.facebookLoginRoute"
                                :google-login-route="headerSetupData.googleLoginRoute"
                                :login-post-route="
                                    headerSetupData.loginPostRoute
                                "
                                :register-route="headerSetupData.registerRoute"
                                :forgot-password-route="
                                    headerSetupData.forgotPasswordRoute
                                "
                                :csrf-token="headerSetupData.csrfToken"
                                v-if="!headerSetupData.isAuthenticated"
                            >
                                <template v-slot:trigger>
                                    <span
                                        class="button button--large button--white"
                                        :class="{
                                            'hidden lg:flex':
                                                hasBottomNavigation,
                                        }"
                                    >
                                        <v-icon icon="add-listing"></v-icon>
                                        Objavite oglas
                                    </span>
                                </template>
                            </v-login>
                        </template>
                    </template>

                    <!-- Main Login Component -->
                    <!-- To open it only once -->
                    <!-- Others should have :login-show="false" -->
                    <v-login
                        :class="{ 'hidden lg:block': hasSearchActive }"
                        :login-show="headerSetupData.loginShow"
                        :login-error="headerSetupData.loginError"
                        :facebook-login-route="headerSetupData.facebookLoginRoute"
                        :google-login-route="headerSetupData.googleLoginRoute"
                        :login-validation-errors="
                            headerSetupData.loginValidationErrors
                        "
                        :login-post-route="headerSetupData.loginPostRoute"
                        :register-route="headerSetupData.registerRoute"
                        :forgot-password-route="
                            headerSetupData.forgotPasswordRoute
                        "
                        :csrf-token="headerSetupData.csrfToken"
                        v-if="!headerSetupData.isAuthenticated"
                    ></v-login>
                    <!-- Temp -->
                    <a
                        class="button button--large hidden md:flex"
                        v-if="headerSetupData.isAuthenticated && !isOnActivation"
                        :href="headerSetupData.profileRoute"
                    >
                        <!-- :href="headerSetupData.logoutRoute" -->
                        <label>
                            <template v-if="headerSetupData.user">
                                {{ headerSetupData.user.name }}
                            </template>
                            <span></span>
                        </label>

                        <template v-if="profileImg !== 0">
                            <img
                            class="pointer-events-none h-5 w-5 select-none"
                                :src="profileImg"
                            />
                        </template>
                        <template v-else>
                            <img
                            class="pointer-events-none h-5 w-5 select-none"
                                :src="$assetsUrl + '/images/profile.webp'"
                                alt=""
                            />
                        </template>
                        <!-- <img
                            :src="$assetsUrl + '/images/profile.webp'"
                            class="pointer-events-none h-5 w-5 select-none"
                        /> -->
                    </a>
                    <a
                        :href="backUrl"
                        class="flex items-center space-x-2 text-form text-black-78"
                        v-if="hasClose"
                    >
                        <v-icon icon="close" size="5"></v-icon>
                        <span>Zapri</span>
                    </a>
                </figure>
            </div>
        </section>
        <section
            is-on-mobile-head
            class="h-[72px] w-full md:hidden"
            :class="{
                hidden: isOnSearchResults,
                hidden: isOnProfile,
                // hidden: isOnListing,
                hidden: mobileSearchMode == 'map',
            }"
        >
            <div
                v-if="isOnIndex || isOnProfile"
                class="container mx-auto flex h-[72px] w-full flex-row items-center justify-between bg-white px-12 pb-4 pt-4"
            >
                <figure>
                    <a href="/">
                        <v-icon icon="n24-beta" class="max-md:h-5"></v-icon>
                    </a>
                </figure>
                <!-- večjezičnost
                <v-dropdown-sm>
                    <template v-slot:trigger>
                        <button class="flex items-center justify-center group">
                            <img src="/assets/images/countries/si.svg" v-if="headerSetupData.country == 'SVN'" alt="" class="h-10 w-10 shadow-sm rounded-full group-hover:shadow">
                            <img src="/assets/images/countries/hr.svg" v-if="headerSetupData.country == 'HRV'" alt="" class="h-10 w-10 shadow-sm rounded-full group-hover:shadow">
                        </button>
                    </template>
                    <template v-slot:content>
                        <div class="flex flex-col gap-3.5">
                            <a href="/drzava/svn" class="hover:text-green">
                                Slovenija
                            </a>
                            <a href="/drzava/hrv" class="hover:text-green">
                                Hrvaška
                            </a>
                        </div>
                    </template>
                </v-dropdown-sm>
                -->
            </div>
            <div
                v-if="isOnListing"
                class="top-actions h-[74px] w-full border-b bg-white"
            >
                <div>
                    <a
                        :href="backUrl"
                        class="flex items-center space-x-2 text-form text-black-78"
                    >
                        <v-icon icon="back" size="5"></v-icon>
                        <span>Nazaj</span>
                    </a>
                </div>
                <div class="flex gap-5" v-if="!isOnActivation">
                    <template v-if="headerSetupData.isAuthenticated">
                        <a
                            class="flex items-center space-x-2 text-form text-black-78"
                            @click="toggleFavourite"
                        >
                            <template v-if="!favourite">
                                <v-icon icon="heart" size="6"></v-icon>
                            </template>
                            <template v-else>
                                <v-icon icon="heart-solid" size="6"></v-icon>
                            </template>
                        </a>
                    </template>
                    <template v-else>
                        <v-login
                            :login-show="false"
                            :login-error="headerSetupData.loginError"
                            :login-post-route="headerSetupData.loginPostRoute"
                            :register-route="headerSetupData.registerRoute"
                            :facebook-login-route="headerSetupData.facebookLoginRoute"
                            :google-login-route="headerSetupData.googleLoginRoute"
                            :forgot-password-route="
                                headerSetupData.forgotPasswordRoute
                            "
                            :csrf-token="headerSetupData.csrfToken"
                        >
                            <template v-slot:trigger>
                                <a
                                    class="flex items-center space-x-2 text-form text-black-78"
                                >
                                    <v-icon icon="heart" size="6"></v-icon>
                                </a>
                            </template>
                        </v-login>
                    </template>
                    <!-- <a
                        class="flex items-center space-x-2 text-form text-black-78"
                    >
                        <v-icon icon="heart" size="6"></v-icon>
                    </a>> -->
                    <v-listing-share
                        on-view-listing-mobile
                        :property="property"
                        :locations="locations"
                    ></v-listing-share>
                </div>
                <div v-else>
                    <a
                        :href="backUrl"
                        class="flex items-center space-x-2 text-form text-black-78"
                        v-if="hasClose"
                    >
                        <v-icon icon="close" size="5"></v-icon>
                        <span>Zapri</span>
                    </a>
                </div>
            </div>
        </section>
        <section
            is-on-mobile-foot
            class="fixed bottom-0 z-10 h-[74px] w-full border-t bg-white lg:hidden"
        >
            <template v-if="isOnIndex">
                <v-header-mobile-bottom-navigation
                    has-home-active
                    :header-setup-data="headerSetupData"
                ></v-header-mobile-bottom-navigation>
            </template>
            <template v-if="isOnSearchResults">
                <v-header-mobile-bottom-navigation
                    has-search-active
                    :header-setup-data="headerSetupData"
                ></v-header-mobile-bottom-navigation>
                <div
                    v-if="hasMapListToggle"
                    class="fixed bottom-24 z-10 flex w-full rounded-full pl-8 pr-8 lg:hidden"
                >
                    <div
                        class="mx-auto flex h-full w-full max-w-lg rounded-full bg-white shadow"
                    >
                        <a
                            @click="mobileSearchMode = 'list'"
                            class="button h-[44px] flex-1 px-4"
                            :class="{
                                'button--white': mobileSearchMode == 'map',
                            }"
                        >
                            <v-icon
                                icon="list"
                                class="text-black-40"
                                size="5"
                                :class="{
                                    'text-white': mobileSearchMode == 'list',
                                }"
                            ></v-icon>
                            <label
                                class="body-medium-button text-black-40"
                                :class="{
                                    'text-white': mobileSearchMode == 'list',
                                }"
                                >Rezultati</label
                            >
                        </a>
                        <a
                            @click="mobileSearchMode = 'map'"
                            class="button h-[44px] flex-1 px-4"
                            :class="{
                                'button--white': mobileSearchMode == 'list',
                            }"
                        >
                            <v-icon
                                icon="map"
                                class="text-black-40"
                                size="5"
                                :class="{
                                    'text-white': mobileSearchMode == 'map',
                                }"
                            ></v-icon>
                            <label
                                class="body-medium-button text-black-40"
                                :class="{
                                    'text-white': mobileSearchMode == 'map',
                                }"
                                >Zemljevid</label
                            >
                        </a>
                    </div>
                </div>
            </template>
            <template v-if="isOnListing">
                <div class="bottom-actions container mx-auto">
                    <div class="flex text-heading-4-bold text-green-49">
                        <span v-if="property.elements.vermarktungsart == 'miete'">
                            <span class="text-green">{{ this.$globalFunctions.formatPrice(property.elements.kaltmiete) }}</span> € / mesec
                        </span>
                        <span v-else>
                            <span class="text-green">{{ this.$globalFunctions.formatPrice(property.elements.kaufpreis) }}</span> €
                        </span>
                    </div>
                    <div>
                        <v-listing-contact
                            :is-authenticated="headerSetupData.isAuthenticated"
                            :header-setup-data="headerSetupData"
                            :property-contact-person="propertyContactPerson"
                            :user="user"
                            :property="property"
                            :agency="agency"
                            :umbrella-organization="umbrellaOrganization"
                            :show-contact-email="showContactEmail"
                            :show-contact-phone="showContactPhone"
                        ></v-listing-contact>
                    </div>
                </div>
            </template>
            <template v-if="isOnRegister">
                <div class="bottom-actions">
                    <div class="flex w-full justify-center">
                        <a class="button" href="">
                            <label>Nadaljujte</label>
                            <v-icon icon="arrow-right"></v-icon>
                        </a>
                    </div>
                </div>
            </template>
            <template v-if="isOnProfile">
                <v-header-mobile-bottom-navigation
                    has-profile-active
                    :header-setup-data="headerSetupData"
                ></v-header-mobile-bottom-navigation>
            </template>
        </section>

        <!-- Main Search with backdrop on trigger -->
        <section v-if="showMainSearch" class="absolute left-0 top-full w-full">
            <!-- white bg -->
            <div class="absolute bottom-8 top-0 -z-10 w-full bg-white"></div>
            <!-- black backdrop -->


            <div class="px-8 md:px-12">
                <div class="relative mx-auto max-w-[1200px]">
                    <div
                        class="absolute right-0 top-2.5 flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-gray"
                        @click="toggleMainSearch"
                    >
                        <v-icon icon="close"></v-icon>
                    </div>
                </div>
                <v-main-search
                    :i18n="headerSetupData.i18n"
                    :enums="headerSetupData.enums"
                    :errors="errors"
                    :current-country="headerSetupData.country == 'SVN' ? 'Slovenija' : 'Hrvaška'"
                >
                </v-main-search>
            </div>
        </section>
    </header>
</template>

<script>
export default {
    props: {
        hasAddListing: {
            type: Boolean,
            default: false,
        },
        hasClose: {
            type: Boolean,
            default: false,
        },
        hasAddListingActive: {
            // copied to HeaderMobileBottomNavigation
            type: Boolean,
            default: false,
        },
        hasSaveAndExit: {
            type: Boolean,
            default: false,
        },
        hasHomeActive: {
            // copied to HeaderMobileBottomNavigation
            type: Boolean,
            default: false,
        },
        hasSearch: {
            type: Boolean,
            default: false,
        },
        hasSearchActive: {
            type: Boolean,
            default: false,
        },
        hasContainer: {
            type: Boolean,
            default: false,
        },
        isFixed: {
            type: Boolean,
            default: false,
        },
        hasBottomNavigation: {
            type: Boolean,
            default: false,
        },
        mobileHasTopActions: {
            type: Boolean,
            default: false,
        },
        isOnSearchResults: {
            type: Boolean,
            default: false,
        },
        isOnIndex: {
            type: Boolean,
            default: false,
        },
        isOnListing: {
            type: Boolean,
            default: false,
        },
        isOnActivation: {
            type: Boolean,
            default: false,
        },
        isOnRegister: {
            type: Boolean,
            default: false,
        },
        isOnProfile: {
            type: Boolean,
            default: false,
        },
        isOnAddListing: {
            type: Boolean,
            default: false,
        },
        hasBottomActions: {
            type: Boolean,
            default: false,
        },
        hasMapListToggle: {
            type: Boolean,
            default: false,
        },
        hideLogo: {
            type: Boolean,
            default: false,
        },
        mobileSearchMode: {
            type: String,
            default: "list",
        },
        hasMiniSearch: {
            type: Boolean,
            default: false,
        },
        headerSetupData: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
            default: {},
        },
        estateOnofficeId: {
            type: Number,
            required: false,
            default: null,
        },
        toggleFavoriteRoute: {
            type: String,
            required: false,
            default: null,
        },
        isFavorite: {
            type: Boolean,
            required: false,
            default: false,
        },
        property: {
            type: Object,
            required: false,
            default: {},
        },
        locations: {
            type: Object,
            required: false,
            default: {},
        },
        propertyContactPerson: {
            type: Object,
            required: false,
            default: {},
        },
        user: {
            type: [Object, null],
            required: false,
            default: {},
        },
        backUrl: {
            type: String,
            required: false,
            default: '',
        },
        agency: {
            type: Object,
            required:false,
            default: null,
        },
        umbrellaOrganization: {
            type: Object,
            required:false,
            default: null,
        },
        showContactEmail: {
            type: Boolean,
            required: false,
            default: true,
        },
        showContactPhone: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
        return {
            showMainSearch: false,
            favourite: false,
            profileImg: "/assets/images/profile.webp",
        };
    },

    watch: {
        mobileSearchMode(newVal) {
            this.$emit("mobile-search-mode-toggled", newVal);
        },
    },

    methods: {
        toggleMainSearch() {
            this.showMainSearch = !this.showMainSearch;
        },
        toggleFavourite() {
            if (this.estateOnofficeId && this.toggleFavoriteRoute) {
                let data = {
                    on_office_id: this.estateOnofficeId,
                };

            axios
                .post(this.toggleFavoriteRoute, data, {
                    headers: {
                        "X-CSRF-TOKEN": this.$csrfToken,
                    },
                })
                .then(
                    (response) => {
                        this.favourite = response.data.status;
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            }
        },
    },
    mounted() {
        this.favourite = this.isFavorite;
        this.showMainSearch =
            !this.hasHomeActive &&
            Object.keys(this.errors).length > 0 &&
            !this.$root.isMobileViewport;
    },
};
</script>
